<div class="col-12">
  <input
    type="file"
    #fileUpload
    style="display: none"
    (change)="onFileSelect($event)"
  />
  <p-button
    (click)="fileUpload.click()"
    label="'upload project document' | sentencecase"
    rounded="true"
    size="large"
    icon="pi pi-plus"
  ></p-button>
  @if(newFile){
      <div class="flex align-items-center justify-content-between mt-4 mb-5">
        <span>{{ newFile.name }} </span>
        <p-button class="ml-4" size="small" [text]="true" icon="true" (click)="removeFile()">
          <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
        </p-button>
      </div>
  }
  @if(showDetailsInput){
  <form [formGroup]="fileDetails">
      <div class="m-3">
        <p-floatLabel>
            <input formControlName="docTitle" type="text" pInputText />
            <label for="docTitle">Title<span class="required">*</span></label>
        </p-floatLabel>
      </div>
      <div class="m-3">
          <p-floatLabel>
            <textarea
              class="w-12"
              formControlName="userInstructions"
              rows="5"
              pInputTextarea
            ></textarea>
            <label for="userInstructions">{{'Instructions for Candidates' | sentenceCase}}</label>
          </p-floatLabel>
      </div>
      <div class="m-3">
        <p-button [disabled]="!fileDetails.valid" label="upload" size="small"  (click)="uploadFile()" [rounded]="true">
            <span class="{{helperService.getEnvironmentName()}}-icon icon-upload-outlined"></span>
        </p-button>
       </div>
    </form>

  }
  @for(file of files; track file){ 
    @if(file){
        <div class="flex align-items-center justify-content-between mt-4 mb-5">
            <span>{{ file.docTitle }} </span>
            <p-button class="ml-4" size="small" [text]="true" icon="true" (click)="onDelete(file._id)">
            <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
            </p-button>
        </div>
     } 
}
</div>
